import ModalResumo from '../components/ModalResumo'
import acessos from '../mixins/acessos'
import AvatarPersona from '../components/AvatarPersona.js'
import outSideClick from '../../modules/outsideCLick'
import ConfirmModal from '../components/ConfirmModal.js'
import { Grid, html as htmlGrid } from 'gridjs'
import GraficoGerencialSai from '../components/GraficoGerencialSai.js'
import { participacaoOptions } from '../constants/participacao_gerencial_sai.js'
import { captacaoSemestralOptions } from '../constants/captacao_semestral_gerencial_sai.js'
import {
	captacaoMensalOptions,
	captacaoSemestralBarraOptions,
} from '../constants/captacao_mensal_gerencial_sai.js'
import { pleOptions } from '../constants/ple_gerencial_sai.js'
import TableGerencialSai from '../components/TableGerencialSai.js'
import ModalAtendimentoGerenciadorSai from '../components/ModalAtendimentoGerenciadorSai.js'
import atendimentoRapido from '../mixins/atendimentoRapido.js'
import ModalInfoAtendimentoGerencial from '../components/ModalInfoAtendimentoGerencial.js'
import atendimentoSequoia from '../mixins/atendimentoSequoia.js'
import lodash from 'lodash'
import processoSeletivo from '../services/processoSeletivo.service.js'
import { URLS } from '../constants/urls.js'

const { errorDefault, api, FormatREALVirgula, debounceFunction, estadosBR } =
	GLOBAL

const url_browser = new URL(window.location.href)

const { getProcessoSeletivo, createProcessoSeletivo, deleteProcessoSeletivo } = processoSeletivo()

export default {
	mixins: [acessos, atendimentoSequoia],
	components: {
		ModalResumo,
		AvatarPersona,
		ConfirmModal,
		GraficoGerencialSai,
		TableGerencialSai,
		ModalAtendimentoGerenciadorSai,
		ModalInfoAtendimentoGerencial,
	},

	data() {
		return {
			listaFundacaoAtendimento: [],
			data: {},
			tableFundacoes: null,
			fundacoesAtivos: [],
			filterFundacoes: '',
			filter_az: '',
			abasFilter: [],
			dashboard_gerencial: [],
			fundosSelect: [],
			modalConfirm: {},
			principais_clientes_cliente_pf:
			global_tables.principais_clientes_cliente_pf,
			principais_prospects: global_tables.principais_prospects,
			principais_sap: global_tables.principais_sap,
			acompanhamento_officers: global_tables.acompanhamento_officers,
			grafico_importancia_estado: [],
			/* 			es: {
				sigla: '',
			}, */
			haveModalResumo: true,
			filterMesAtivo: '',
			tipoParticipacaoFundo: 'nominal',
			chartParticipacaoFundo: null,
			chartCaptacaoSemestral: null,
			chartCaptacaoMensal: null,
			chartPle: null,
			_copiaOptionsChartCaptacaoSemestral: null,
			_copiaSerieChartCaptacaoSemestral: null,
			_copiaCategoriasChartCaptacaoSemestral: null,
			isCaptacaoSemestralSelected: false,
			isLoadChartCaptacaoMensal: false,
			fundacaoId: null,
			fundacaoSequoiaInfoSelecionado: null,
			atendimentoSequoiaEditarSelecionado: null,
			isModoEditarAtendimentoSai: false,
			isLoadingModalAtendimentoSai: false,
		}
	},

	methods: {
		async enviarAtendimentoRapido(e) {
			const { tituloAtendimento, textoAtendimento, dataAtendimento } = e

			try {
				this.isLoadingModalAtendimentoSai = true
				const responseAtendimentoRapido = await this.createAtendimentoRapido(
					'0',
					textoAtendimento,
					tituloAtendimento,
					dataAtendimento ?? null
				)
				
				modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai')

				window.location = `${window.origin}/atendimento/dashboard_gerencial_fundacao/?az=${this.filter_az}`
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingModalAtendimentoSai = false
			}
		},

		async editarAtendimentoRapidoSequoia(atendimentoData) {
			try {
				this.isLoadingModalAtendimentoSai = true

				const {
					textoAtendimento,
					tituloAtendimento,
					dataAtendimento,
					idAtendimento,
				} = atendimentoData
				const responseAtendimentoRapido = await this.updateAtendimentoRapido(
					textoAtendimento,
					tituloAtendimento,
					dataAtendimento,
					idAtendimento
				)

				modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai')

				window.location = `${window.origin}/atendimento/dashboard_gerencial_fundacao/?az=${this.filter_az}`
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingModalAtendimentoSai = false
			}
		},

		closeModalAtendimentoRapido() {
			this.isModoEditarAtendimentoSai = false
			this.atendimentoSequoiaEditarSelecionado = null
			this.clearClienteAtendimentoRapido()
		},

		openModalInfoGerencial(fundacaoSelecionado) {
			const { atendimentosFundacao } = fundacaoSelecionado
			this.fundacaoSequoiaInfoSelecionado = atendimentosFundacao
			modal_padrao_vue.openModal('modal_info_gerencial_sai')

			this.$nextTick(() => {
				const modals = document.querySelectorAll(
					'[data-active="modal_info_gerencial_sai"]'
				)
				if (modals && modals.length > 0) {
					modals.forEach((item) => {
						item.style.width = '36rem'
					})
				} else {
					console.warn('Modal ainda não está no DOM')
				}
			})
		},
		onClickEditarAtendimentoSequoia(idAtendimento) {
			if (this.fundacaoSequoiaInfoSelecionado && idAtendimento) {
				const atendimentoSelecionado =
					this.fundacaoSequoiaInfoSelecionado.atendimentos.find(
						(item) => item.id === idAtendimento
					)
				this.atendimentoSequoiaEditarSelecionado = atendimentoSelecionado

				if (this.atendimentoSequoiaEditarSelecionado) {
					this.isModoEditarAtendimentoSai = true
					modal_padrao_vue.closeModal('modal_info_gerencial_sai')

					setTimeout(() => {
						this.openModalAtendimentoRapidoGerencial({
							id: this.atendimentoSequoiaEditarSelecionado.fundacao,
						})
					}, 1000)
				}
			}
		},
		openModalAtendimentoRapidoGerencial(fundacao) {
			this.addClienteAtendimentoRapido(fundacao.id)

			modal_padrao_vue.openModal('modal_atendimento_gerencial_sai')
		},
		getAbaAZById(id) {
			if (!id) return ''

			return this.abasFilter.find((item) => item.id === Number(id))?.nome ?? ''
		},
		initPLeChart() {
			this.chartPle = new ApexCharts(
				document.querySelector('#chart_ple'),
				pleOptions
			)
			this.chartPle?.render()
		},

		initParticipacaoChart() {
			this.chartParticipacaoFundo = new ApexCharts(
				document.querySelector('#chart_segmento_sai'),
				participacaoOptions
			)
			this.chartParticipacaoFundo.render()
		},

		initCaptacaoSemestralChart() {
			this.chartCaptacaoSemestral = new ApexCharts(
				document.querySelector('#chart_bar'),
				captacaoSemestralOptions
			)
			this.chartCaptacaoSemestral.render()
		},

		initCaptacaoMensalChart() {
			this.addEventListenerCaptacaoSemestralChart()

			this.chartCaptacaoMensal = new ApexCharts(
				document.querySelector('#chart_captacao_mensal'),
				this._copiaOptionsChartCaptacaoSemestral
			)
			this.chartCaptacaoMensal?.render()
		},

		initAllChart() {
			this.initParticipacaoChart()
			this.initCaptacaoSemestralChart()
			this.initCaptacaoMensalChart()
			this.initPLeChart()
		},

		addEventListenerCaptacaoSemestralChart() {
			this._copiaOptionsChartCaptacaoSemestral = lodash.cloneDeep(
				captacaoMensalOptions
			)

			if (!this._copiaOptionsChartCaptacaoSemestral.chart.events) {
				this._copiaOptionsChartCaptacaoSemestral.chart.events = {}
			}

			this._copiaOptionsChartCaptacaoSemestral.chart.events.dataPointSelection =
				(event, chartContext, config) => {
					if (!this.isCaptacaoSemestralSelected) {
						const barraSelecionadaIdx = config.dataPointIndex
						const todasSeries = chartContext.w.config.series
						this._copiaCategoriasChartCaptacaoSemestral =
							chartContext.w.config.xaxis.categories

						const todosOsValoresBarraSelecionada = todasSeries
							.filter((item) => {
								return item && item.data[barraSelecionadaIdx]
							})
							.map((item) => {
								return {
									name: item.name,
									data: [
										{
											y: Number(item.data[barraSelecionadaIdx]),
											x: this._copiaCategoriasChartCaptacaoSemestral[
												barraSelecionadaIdx
											],
										},
									],
								}
							})

						this._copiaSerieChartCaptacaoSemestral = todasSeries

						const baseOptions = lodash.cloneDeep(captacaoMensalOptions)
						const barraOptions = lodash.cloneDeep(captacaoSemestralBarraOptions)

						this._copiaOptionsChartCaptacaoSemestral = lodash.merge(
							{},
							baseOptions,
							barraOptions
						)

						this._copiaOptionsChartCaptacaoSemestral.chart.events =
							lodash.cloneDeep(
								this.chartCaptacaoMensal?.w?.config?.chart?.events
							)

						this._copiaOptionsChartCaptacaoSemestral.series = [
							...todosOsValoresBarraSelecionada,
						]

						this.chartCaptacaoMensal?.destroy()

						this.chartCaptacaoMensal = new ApexCharts(
							document.querySelector('#chart_captacao_mensal'),
							this._copiaOptionsChartCaptacaoSemestral
						)
						this.chartCaptacaoMensal?.render()

						this.isCaptacaoSemestralSelected = true
					} else {
						this.recreateChartCaptacaoSemestral()
						this.isCaptacaoSemestralSelected = false
					}
				}
		},

		recreateChartCaptacaoSemestral() {
			this._copiaOptionsChartCaptacaoSemestral = lodash.cloneDeep(
				captacaoMensalOptions
			)

			this._copiaOptionsChartCaptacaoSemestral.chart.events = lodash.cloneDeep(
				this.chartCaptacaoMensal?.w?.config?.chart?.events
			)

			this._copiaOptionsChartCaptacaoSemestral.series =
				this._copiaSerieChartCaptacaoSemestral

			this._copiaOptionsChartCaptacaoSemestral.xaxis.categories =
				this._copiaCategoriasChartCaptacaoSemestral

			this.chartCaptacaoMensal?.destroy()

			this.chartCaptacaoMensal = new ApexCharts(
				document.querySelector('#chart_captacao_mensal'),
				this._copiaOptionsChartCaptacaoSemestral
			)

			this.chartCaptacaoMensal?.render()
		},

		async updateChartCaptacaoMensalRecreate() {
			if (this.isCaptacaoSemestralSelected) {
				this.isLoadChartCaptacaoMensal = true
				this.recreateChartCaptacaoSemestral()
				await new Promise((resolve) => setTimeout(resolve, 1000))
				this.isCaptacaoSemestralSelected = false
				this.isLoadChartCaptacaoMensal = false
			}
		},

		reloadFilter(fundoID) {
			window.location.href = `/atendimento/dashboard_gerencial_fundacao/?az=${fundoID}`
		},

		openModal({ currentTarget }, idActive, politicaActive) {
			const id = idActive || currentTarget?.getAttribute('data-id')
			const politica =
				politicaActive || currentTarget?.getAttribute('data-politica')

			this.$refs.modalResumo.OpenModalResumo({
				id,
				politica,
				atendimentoID: null,
			})
		},

		debounce(fn, wait, timing) {
			return (...args) => {
				clearTimeout(timing)
				timing = setTimeout(() => fn(...args), wait)
			}
		},

		submitDropdown() {
			const form = document.querySelector('#form-dropdown')

			form.submit()
		},

		patrimonioFormated(patrimonio) {
			if (patrimonio == '-' || patrimonio?.toLowerCase() == 'none') return '-'
			const value = FormatREALVirgula(patrimonio)
			return value
		},

		arrExample(n) {
			return Array(n).fill(0)
		},

		async getDadosCharts() {
			try {
				const { data: response } = await api.get(
					`/atendimento/graficos_dashboard_gerencial/?az=${this.filter_az}`
				)
				return response
			} catch (err) {
				errorDefault(err)
			}
		},

		fillCharts(data, chart) {
			if (!this.isFundacao) {
				if (chart == chartSegmento) {
					let currentData
					if (this.isFundacao) {
						const { grafico_segmento_fundacao } = data
						currentData = grafico_segmento_fundacao
					} else {
						const { grafico_segmento_cliente_pf } = data
						currentData = grafico_segmento_cliente_pf
					}
					let series = currentData?.map((obj) => Number(obj.value))
					chart.updateOptions({
						series,
						labels: currentData.map((obj) => obj.name),
					})
				}

				if (chart == chartProdutos) {
					let currentData
					if (this.isFundacao) {
						const { grafico_principais_produtos_fundacao } = data
						currentData = grafico_principais_produtos_fundacao
					} else {
						const { grafico_principais_produtos_cliente_pf } = data
						currentData = grafico_principais_produtos_cliente_pf
					}

					const series = currentData.map((obj) => Number(obj.value))
					chart.updateOptions({
						series,
						labels: currentData.map((obj) => obj.name),
					})
				}
			} else {
				if (chart == this.chartParticipacaoFundo) {
					let currentParticipacaoFundo = []

					if (this.tipoParticipacaoFundo === 'ajustado') {
						currentParticipacaoFundo = data['grafico_participacao_fundo2']
					} else if (this.tipoParticipacaoFundo === 'nominal') {
						currentParticipacaoFundo = data['grafico_participacao_fundo']
					}

					let currentData = currentParticipacaoFundo?.sort(
						(a, b) => b.value - a.value
					)

					let series = currentData.map((obj) => Number(obj.value))

					chart.updateOptions(
						{
							series,
							labels: currentData.map((obj) => obj.name),
						},
						true,
						true,
						true
					)
				}

				if (chart == this.chartPle) {
					const { grafico_evolucao_patrimonio } = data
					let currentData = grafico_evolucao_patrimonio
					let series = [
						{
							name: 'Patrimônio',
							data: currentData.map((obj) => Number(obj.value)),
						},
					]
					chart.updateOptions({
						series,
						labels: currentData.map((obj) => obj.name),
					})
				}
				if (chart == this.chartCaptacaoSemestral) {
					//const { captacoes } = data

					let currentData = data
					let series = [
						{
							name: 'Ajustado',
							type: 'column',
							data: currentData.map((obj) => Number(obj.captacao_ajustada)),
						},
						{
							name: 'Total',
							type: 'column',
							data: currentData.map((obj) => Number(obj.captacao_total)),
						},

						{
							name: 'Meta',
							type: 'line',
							data: currentData.map((obj) => Number(obj.meta)),
						},
					]

					const seriesIdx = 1
					const dataPoints = series[seriesIdx].data
					const cats = currentData.map((obj) => obj.semestre)

					const points = dataPoints
						.map((v, i) => {
							return {
								x: cats[i],
								y: v,
								marker: {
									size: 0,
								},
								label: {
									text: GLOBAL.FMoneyK(v),
									offsetY: v >= 0 ? -1 : 24,
									offsetX: 6,
									style: {
										fontSize: '12px',
										color: v >= 0 ? '#003769' : '#C11F39',
										background: 'transparent',
									},
									borderWidth: 0,
									borderColor: 'transparent',
								},
							}
						})
						.filter((pt) => pt)

					chart.updateOptions({
						series,
						labels: currentData.map((obj) => obj.semestre),
						chart: {
							width:
								currentData?.length <= 12
									? '100%'
									: `${currentData?.length * 40}px`,
						},

						annotations: { points: points },
					})
				}

				if (chart == this.chartCaptacaoMensal) {
					const { fundos_semestre, nomes_fundos } = data

					let arr = Object.entries(fundos_semestre)
					let series = []
					let label = []
					for ([chave, itemFundoSemestre] of arr) {
						label.push(chave)
					}

					nomes_fundos?.forEach((array) => {
						let valores = []
						for ([chave, itemFundoSemestre] of arr) {
							let valor = 0
							if (itemFundoSemestre?.length == 1) {
								if (itemFundoSemestre[0].nome === array[0]) {
									valor = itemFundoSemestre[0].valor
								} else {
									valor = 0
								}
							} else {
								itemFundoSemestre?.forEach((item, index) => {
									if (index == 0) {
										if (item.nome === array[0]) {
											valor = item.valor
										}
									} else {
										if (item[0].nome === array[0]) {
											valor = item[0].valor
										}
									}
								})
							}
							valores.push(valor)
						}
						series = [
							...series,
							{
								name: array[0],
								data: valores,
							},
						]
						valores = []
					})

					chart.updateOptions({
						series,

						xaxis: {
							type: 'category',
							categories: label,
						},
					})
				}
			}
		},

		alternarValor() {
			const btn = document.querySelector('.alternar-valor')
			const btnAjustado = document.querySelector('.alternar-valor-ajustado')

			btnAjustado.addEventListener('click', async (eventClick) => {
				this.toggleButtonClasses(eventClick, btn)

				let data = await this.getDadosCharts()

				const { fundos_semestre, nomes_fundos } = data

				let arr = Object.entries(fundos_semestre)
				let series = []
				let label = []
				for ([chave, itemFundoSemestre] of arr) {
					label.push(chave)
				}

				nomes_fundos.forEach((array) => {
					let valores = []
					for ([chave, itemFundoSemestre] of arr) {
						let valor = 0
						if (itemFundoSemestre?.length == 1) {
							if (itemFundoSemestre[0].nome === array[0]) {
								valor = itemFundoSemestre[0].valor_ajustado
							} else {
								valor = 0
							}
						} else {
							itemFundoSemestre.forEach((item, index) => {
								if (index == 0) {
									if (item.nome === array[0]) {
										valor = item.valor_ajustado
									}
								} else {
									if (item[0].nome === array[0]) {
										valor = item[0].valor_ajustado
									}
								}
							})
						}
						valores.push(valor)
					}
					series = [
						...series,
						{
							name: array[0],

							data: valores,
						},
					]
					valores = []
				})

				await this.updateChartCaptacaoMensalRecreate()

				this.chartCaptacaoMensal?.updateOptions({
					series,

					xaxis: {
						type: 'category',
						categories: label,
					},
				})
			})

			btn.addEventListener('click', async (eventClick) => {
				this.toggleButtonClasses(eventClick, btnAjustado)
				let data = await this.getDadosCharts()

				await this.updateChartCaptacaoMensalRecreate()

				this.fillCharts(data, this.chartCaptacaoMensal)
			})
		},

		addEventBtnsFiltroFundacoes() {
			const btnFiltrar = document.querySelector('.filtrarFundacoes')
			const btnLimpar = document.querySelector('.limparFiltros')
			if (btnFiltrar) {
				btnFiltrar.addEventListener('click', () => this.filtrarFundacoes())
			}
			if (btnLimpar) {
				btnLimpar.addEventListener('click', () => this.limparFundacoes())
			}
		},

		limparFundacoes() {
			this.filterFundacoes = ''

			const acima = document.querySelector('input[name="acima"]')
			const abaixo = document.querySelector('input[name="abaixo"]')

			const selectEstado = document.querySelector('select[name="estado"]')
			const choiceEstado = GLOBAL.getChoicesActive(
				selectEstado.id,
				listOfChoices
			)

			const selectFundo = document.querySelector('select[name="fundo_sigla"]')
			const choiceFundo = GLOBAL.getChoicesActive(selectFundo.id, listOfChoices)

			acima.value = ''
			abaixo.value = ''
			choiceEstado.removeActiveItems()
			choiceFundo.removeActiveItems()

			this.tableFundacoes
				?.updateConfig({
					server: {
						url: `${window.origin}${URLS.api_fundacao}?ativo=True${this.filterFundacoes}`,
						then: (data) => this.mapAndFilterSolicitations(data.results),
						total: (data) => data.count,
					},
				})
				.forceRender()
		},

		async filtrarFundacoes() {
			const acima = document.querySelector('input[name="acima"]')
			const abaixo = document.querySelector('input[name="abaixo"]')

			const selectEstado = document.querySelector('select[name="estado"]')
			const choiceEstado = GLOBAL.getChoicesActive(
				selectEstado.id,
				listOfChoices
			)
			const valuesEstadosSelecionados = choiceEstado.getValue(true)
			const selectFundo = document.querySelector('select[name="fundo_sigla"]')
			const choiceFundo = GLOBAL.getChoicesActive(selectFundo.id, listOfChoices)
			const valuesFundosSelecionadas = choiceFundo.getValue(true)

			let filter = ''
			filter += '&fundo_sigla=' + valuesFundosSelecionadas?.join(',')
			filter += '&estado=' + valuesEstadosSelecionados?.join(',')

			filter += handleCallback(
				`acima,${Number(GLOBAL.FormatREALBackEnd(acima.value)) || ''}`
			)

			filter += handleCallback(
				`abaixo,${Number(GLOBAL.FormatREALBackEnd(abaixo.value)) || ''}`
			)

			function handleCallback(itemFilter) {
				const filtro = itemFilter?.split(',')
				const [param, value] = filtro

				let filtersOBJ = {}
				filtersOBJ[param] = value

				const filtros = Object.entries(filtersOBJ).map(
					([key, value]) => `&${key.trim()}=${value.trim()}`
				)

				const newFilters = `${filtros.join('')}`

				return newFilters
			}

			filter += `&az=${url_browser.split('=')[1]}`

			this.filterFundacoes = filter
			this.tableFundacoes
				?.updateConfig({
					server: {
						url: `${window.origin}${URLS.api_fundacao}?ativo=True${this.filterFundacoes}`,
						then: (data) => this.mapAndFilterSolicitations(data.results),
						total: (data) => data.count,
					},
				})
				.forceRender()
		},

		mapSolicitacao(item) {
			const objTable = {
				politica: item.politica,
				id: item.id,
				nome: item.nome,
				patrimonio: item.patrimonio_unifinance,
				estado: item.estado,
				sigla_fundo: item.sigla_fundo?.join(', '),
			}

			return objTable
		},

		mapAndFilterSolicitations(solicitacoes) {
			const _arrData = solicitacoes?.map((item) => this.mapSolicitacao(item))
			const solicitacoesFiltradas = _arrData

			return solicitacoesFiltradas.map((item) => Object.values(item))
		},

		iniciarTabelaGenerica(
			tableSelector,
			columns,
			url,
			customThenCallback,
			count,
			by
		) {
			const table = document.querySelector(tableSelector)

			const gridInstance = new Grid({
				search: false,
				resizable: true,
				columns: columns,
				data: [],
				autoWidth: true,
				width: '100%',
				sort: false,
				server: {
					url: url,
					then: (data) => customThenCallback(data),
					total: count,
				},
				search: {
					debounceTimeout: 500,
					server: {
						url: (prev, keyword) => {
							return `${prev}&search=${keyword}&paginate_by=9999&az=${
								url_browser.search.split('=')[1]
							}`
						},
					},
				},

				pagination: {
					enabled: true,
					limit: by ?? 10,
					summary: true,
					server: {
						url: (urlApi, page, limit) =>
							`${urlApi}&page=${++page}&paginate_by=${limit}&az=${
								url_browser.search.split('=')[1]
							}`,
					},
				},
				style: {
					container: { border: 'none' },
					table: { border: 'none' },
					tr: { border: 'none' },
					th: { 'border-bottom': '1px solid #e9ecef' },
					td: {
						'border-bottom': '1px solid #e9ecef',
						cursor: 'pointer',
						color: '#495057',
						'font-family': 'Roboto Flex',
						'font-size': '14px',
						'font-weight': 500,
						'line-height': '150%',
						'letter-spacing': '-0.28px',
					},
					footer: { border: 'none' },
				},
				language: {
					search: {
						placeholder: 'Busque aqui...',
					},
					pagination: {
						previous: '<',
						next: '>',
						to: '/',
						of: 'de',
						showing: 'Mostrando',
						results: () => 'Resultados',
					},
				},
			})

			gridInstance.render(table)
			return gridInstance
		},

		iniciartableFundacoesAtivo() {
			const columns = [
				{ name: 'politica', hidden: true, width: '40px' },
				{ name: 'ID', hidden: true, width: '40px' },
				// { name: 'tipo-solicitacao', hidden: true },
				// { name: 'conteudo-editado', hidden: true },
				// { name: 'index', hidden: true },
				{
					name: 'Nomes',
					hidden: false,
					width: '360px',
					formatter: (cell, row) => {
						return cell
							? htmlGrid(html`<div class="flex gap-4 items-center w-full">
									<div class="cursor-pointer">
										<div class="inline-flex justify-center">
											<svg
												class="h-40 w-40"
												style="${GLOBAL.generateAvatarColor(
													row.cells[0].data
												)}">
												<use xlink:href="#icon_person"></use>
											</svg>
										</div>
									</div>
									${cell}
							  </div>`)
							: htmlGrid(html`<div class="flex gap-4 items-center"></div>`)
					},
				},
				{
					name: 'Patrimônio',
					hidden: false,
					width: '200px',
					formatter: (cell) => {
						if (cell) return GLOBAL.formatReal2(cell)
					},
				},
				{
					name: 'Estado',
					width: '200px',
					hidden: false,
					formatter: (cell) => {
						const estado = estadosBR.find(
							(estado) => Number(estado.id) === Number(cell)
						)
						if (cell) return estado?.nome
					},
				},
				{
					name: 'Fundos',
					width: '300px',
					hidden: false,
					// formatter: (cell) => {
					// 	console.log({ cell })
					// },
				},
				// {
				// 	name: 'Officer',
				// 	formatter: (cell) => this.formatOfficersNames([{ nome: cell }]),
				// },
				// {
				// 	name: htmlGrid(
				// 		'<div style="white-space: normal;">Tipo de solicitação</div>'
				// 	),
				// },
				// {
				// 	name: htmlGrid(
				// 		'<div style="white-space: normal;">Data de Solicitação</div>'
				// 	),
				// 	formatter: (cell) => GLOBAL.formatDateObject(new Date(cell)),
				// },
				// { name: 'Status' },
				// {
				// 	name: '',
				// 	width: '120px',
				// 	formatter: (cell, row) => this.renderAcoes(row),
				// },
			]
			this.tableFundacoes = this.iniciarTabelaGenerica(
				'#table_fundacoes_ativos',
				columns,
				`${window.origin}${URLS.api_fundacao}?ativo=True${this.filterFundacoes}`,
				(data) => this.mapAndFilterSolicitations(data.results),
				(data) => data.count,
				document.querySelector('#select-table').value
			)
			this.tableFundacoes.on('rowClick', (...args) => {
				const dados = args[1]

				const politica = dados.cells[0].data
				const id = dados.cells[1].data

				this.openModal({}, id, politica)
			})
		},

		sortedArray(event, key, dataKey, number) {
			// this.stateSave.searchs.searchFilterAtendimentos = (a) => a
			const target = event.currentTarget
			const att = target.getAttribute('order')

			target
				.closest('thead')
				.querySelectorAll('th')
				.forEach((el) => el !== target && el.removeAttribute('order'))

			if (att == 'up') target.setAttribute('order', 'down')
			if (att == 'down') target.setAttribute('order', 'up')
			if (!att) target.setAttribute('order', 'up')

			const clone = this[dataKey]

			const result = clone.sort((a, b) => {
				const A = number
					? a[key].replaceAll('.', '').replaceAll(',', '')
					: a[key].toLowerCase()
				const B = number
					? b[key].replaceAll('.', '').replaceAll(',', '')
					: b[key].toLowerCase()

				if (number) {
					return A - B
				} else {
					if (A < B) return -1
					if (B > A) return 1

					return 0
				}
			})

			this[dataKey] = att == 'up' ? result : result.reverse()
		},

		// getAtendimentos() {
		// 	console.log("Hello darknees my old friend.");
		// },

		// getAtendimentosQuentes() {
		// 	console.log("Hello darknees my old friend.");

		// },

		// openModal({ currentTarget }) {
		// 	const id = currentTarget.getAttribute("data-id")
		// 	const politica = currentTarget.getAttribute("data-politica")
		// 	this.$refs.modalResumo.OpenModalResumo({ id, politica, atendimentoID: 0 });

		// }
		openModalProcesso() {
			modal_padrao.openModal('modal_filtro')
		},

		openModalDeleteProcesso(id) {
			this.modalConfirm = {
				open: true,
				text: `Deseja mesmo excluir esse processo? `,
				data: { id },
				id: 'delete_processo',
				botao: 'Excluir',
				header: 'Excluir Processo',
			}
		},

		hiddenSectionModal() {
			const modal = document.querySelector('.modal_padrao')
			const btns = document.querySelectorAll('.btn-modal')

			btns.forEach((i) => {
				i.addEventListener('click', () => {
					const id = i.dataset.id
					modal.querySelectorAll(`section`).forEach((i) => {
						i.classList.add('hidden')
					})
					modal
						.querySelector(`section[data-id=${id}]`)
						.classList.remove('hidden')
				})
			})
		},

		/* fillMap() {
			let colors = [
				'#D2E2F3',
				'#93C7FF',
				'#83BFFF',
				'#75B5F0',
				'#74B7FF',
				'#71B5FF',
				'#6BA4D4',
				'#639DD4',
				'#59A9FF',
				'#55A7FF',
				'#52A8FF',
				'#4FA7FF',
				'#46A3FF',
				'#459EF6',
				'#2D90ED',
				'#2A94FF',
				'#2793FF',
				'#0080FF',
				'#699CC9',
				'#528FC4',
				'#3A7DB8',
				'#437199',
				'#437199',
				'#186EBF',
				'#195386',
				'#164A78',
				'#164269',
				'#163C5E',
				'#153654',
				'#153047',
			].reverse()

			const estadosOrdenados = this.grafico_importancia_estado
				.sort(function (x, y) {
					return x.value - y.value
				})
				.reverse()

			estadosOrdenados.forEach((regiao, i) => {
				const path = document.querySelector(
					`.svg-es path[data-es="${regiao.name}"]`
				)
				if (path) {
					if (regiao.value > 0) {
						path.style.fill = colors[i]
					} else {
						path.style.fill = '#D2E2F3CC'
					}
				}
			})
		},

		async hoverES(e, es) {
			const tooltip = document.querySelector('.tooltip-es')
			tooltip.style.opacity = 0
			tooltip.style.transform = 'translateY(16px)'

			const path = document.querySelector(`.svg-es path[data-es="${es}"]`)

			this.es.sigla = es

			const data = this.grafico_importancia_estado.find(
				(obj) => obj.name.toLowerCase().trim() == es.toLowerCase()
			)

			if (data) {
				this.es = {
					sigla: data.name + ' - ',
					fullName: data.nome,
					value: 'R$ ' + this.patrimonioFormated(data.value),
				}
			} else {
				this.es = {
					sigla: '',
					fullName: 'Sem dados',
					value: '',
				}
			}

			tooltip.style.opacity = 1
			tooltip.style.transform = 'translateY(0)'
		},

		hoverLeave(e) {
			this.es = {
				sigla: '',
			}
			const tooltip = document.querySelector('.tooltip-es')
			tooltip.style.opacity = 0
			tooltip.style.transform = 'translateY(16px)'
		}, */

		addBuscaSelect(listOfChoices) {
			const fundacao = document.querySelector('[name=fundacao]')

			if (!fundacao) return
			const hasAttr = fundacao.getAttribute('js-choices-props')
			const props = hasAttr ? JSON.parse(hasAttr) : {}

			let newFundacao = GLOBAL.initChoices(fundacao, {
				searchEnabled: true,
				searchChoices: true,
				itemSelectText: 'Selecionar',
				noResultsText: 'Nada Encontrado...',
				noResultsText: '...',
				noChoicesText: '...',
				...props,
			})

			window.listOfChoices = [...listOfChoices, newFundacao]
		},

		toggleDisablebBtnNovoProcesso(fundacaoValue) {
			const btn = document.querySelector('.submit-processo')
			if (fundacaoValue) {
				btn.classList.remove('disabled')
			} else {
				btn.classList.add('disabled')
			}
		},

		eventProcesso() {
			const fundacao = document.querySelector('[name=fundacao]')
			const btn = document.querySelector('.submit-processo')
			fundacao.addEventListener('change', () => {
				this.toggleDisablebBtnNovoProcesso(fundacao.value)
			})
			this.toggleDisablebBtnNovoProcesso(fundacao.value)

			btn.addEventListener('click', () => {
				this.cadastrarProcessoSeletivo()
			})
		},

		limpaDados(dados) {
			let arrDados = Object.entries(dados)
			for ([key, item] of arrDados) {
				if (key == 'fundacao') {
					GLOBAL.setValueInChoices(item.id, '')
				}
				item.value = ''
			}
			//	this.eventProcesso()
		},

		async cadastrarProcessoSeletivo() {
			let elementos = {
				fundacao: document.querySelector('[name=fundacao]'),
				estrategia: document.querySelector('[name=estrategia]'),
				valor: document.querySelector('[name=valor]'),
				data: document.querySelector('[name=deadline]'),
				observacoes: document.querySelector('[name=observacoes]'),
			}
			let data = {
				fundacao: elementos.fundacao.value || null,
				estrategia: elementos.estrategia.value,
				valor: elementos.valor.value
					? GLOBAL.FormatREALBackEnd(elementos.valor.value)
					: null,
				data: elementos.data.value
					? elementos.data.value.split('/').reverse().join('-')
					: null,
				observacoes: elementos.observacoes.value || null,
			}

			try {
				const response  = await createProcessoSeletivo(data)

				await this.populaProcessos()
				GLOBAL.showToastify('Processo cadastrado')
				this.limpaDados(elementos)

				return response
			} catch (err) {
				console.log(err)
				GLOBAL.showToastify('Processo não cadastrado')
			}
		},

		geraTemplateProcesso(i) {
			return html`<tr class="" data-tippy-content="${i.observacoes ?? '-'}">
				<td class="py-10">${i.nome_fundacao}</td>
				<td class="py-10">${i.estrategia || '-'}</td>

				<td class="py-10">${i.data?.split('-').reverse().join('/') || '-'}</td>
				<td class="py-10">
					<div class="flex items-center">
						R$ ${GLOBAL.FormatREAL(i.valor) || GLOBAL.FormatREAL('0.00')}
					</div>
				</td>
				<td class="py-10">
					<div class="flex items-center justify-center">
						<button
							type="button"
							id_processo="${i.id}"
							class="delete_processo w-full relative transition-transform place-items-center   cursor-pointer  text-primary-pure">
							<svg class="w-20 h-20 ">
								<use xlink:href="#icon_delete"></use>
							</svg>
						</button>
					</div>
				</td>
			</tr>`
		},

		addClickDeleteProcesso() {
			document.querySelectorAll('.delete_processo').forEach((button) => {
				button.addEventListener('click', () => {
					const id = button.getAttribute('id_processo')

					this.openModalDeleteProcesso(id)
				})
			})
		},

		async deleteProcessoSeletivo() {
			try {
				const id = this.modalConfirm.data?.id

				const responseDelete = await deleteProcessoSeletivo(id)

				if (responseDelete.data?.error) {
					throw new Error(responseDelete.data?.error)
				}
				GLOBAL.showToastify('✅ Processo excluido com sucesso')
				this.modalConfirm = {}
				await this.populaProcessos()
			} catch (e) {
				GLOBAL.showToastify(`❌ ${e.message || 'Erro ao excluir processo'}`)
			}
		},

		async populaProcessos() {
			try {
				const response  = await getProcessoSeletivo()
				const body = document.querySelector('.body-processos-seletivos')
				body.innerHTML = ''
				response?.results.forEach((i) => {
					body.innerHTML += this.geraTemplateProcesso(i)
				})
				this.addClickDeleteProcesso()
				tippy('[data-tippy-content]', {
					allowHTML: true,
					placement: 'top-start',
					boundary: 'HTMLElement',
				})
				return response
			} catch (err) {
				console.log(err)
			}
		},

		async filterValuesChart(qtdMeses) {
			const {
				captacoes,
				captacoes_12_meses,
				captacoes_24_meses,
				captacoes_36_meses,
			} = await this.getDadosCharts()
			if (qtdMeses === this.filterMesAtivo) {
				this.filterMesAtivo = ''
			} else {
				this.filterMesAtivo = qtdMeses
			}
			switch (this.filterMesAtivo) {
				case 12:
					this.fillCharts(captacoes_12_meses, this.chartCaptacaoSemestral)
					return
				case 24:
					this.fillCharts(captacoes_24_meses, this.chartCaptacaoSemestral)
					return
				case 36:
					this.fillCharts(captacoes_36_meses, this.chartCaptacaoSemestral)
					return
				default:
					this.fillCharts(captacoes, this.chartCaptacaoSemestral)
					return
			}
		},

		toggleButtonClasses(eventClick, buttonNoClicked) {
			eventClick.target.classList.remove('quartenary')
			eventClick.target.classList.add('secondary')

			buttonNoClicked.classList.add('quartenary')
			buttonNoClicked.classList.remove('secondary')
		},

		setParticipationChartOptions(responseDadosCharts) {
			let currentParticipacaoFundo = []

			if (this.tipoParticipacaoFundo === 'ajustado') {
				currentParticipacaoFundo =
					responseDadosCharts['grafico_participacao_fundo2']
			} else if (this.tipoParticipacaoFundo === 'nominal') {
				currentParticipacaoFundo =
					responseDadosCharts['grafico_participacao_fundo']
			}

			const sortParticipacaoFundo = currentParticipacaoFundo.reverse()

			const labels = sortParticipacaoFundo.map(
				(item_grafico) => item_grafico.name
			)
			const series = sortParticipacaoFundo.map((item_grafico) =>
				Number(item_grafico.value)
			)

			this.chartParticipacaoFundo.updateOptions({
				series,
				labels,
			})

			window.dispatchEvent(new Event('resize'))
		},
		async handleClickButtonAjustado(eventClick, buttonValueNominal) {
			this.toggleButtonClasses(eventClick, buttonValueNominal)
			const responseDadosCharts = await this.getDadosCharts()

			this.tipoParticipacaoFundo = 'ajustado'

			this.setParticipationChartOptions(responseDadosCharts)

			/* this.fillCharts(responseDadosCharts, chartParticipacaoFundo) */
		},

		async handleClickbuttonNominal(eventClick, buttonValueAjustado) {
			this.toggleButtonClasses(eventClick, buttonValueAjustado)
			const responseDadosCharts = await this.getDadosCharts()

			this.tipoParticipacaoFundo = 'nominal'

			this.setParticipationChartOptions(responseDadosCharts)

			/* this.fillCharts(responseDadosCharts, chartParticipacaoFundo) */
		},

		initializeChartToggle() {
			const buttonValueNominal = document.querySelector('.chart-part')
			const buttonValueAjustado = document.querySelector('.chart-part-ajustado')

			buttonValueAjustado.addEventListener('click', async (eventClick) =>
				this.handleClickButtonAjustado(eventClick, buttonValueNominal)
			)

			buttonValueNominal.addEventListener('click', async (eventClick) =>
				this.handleClickbuttonNominal(eventClick, buttonValueAjustado)
			)
		},

		async setFilterAz() {
			const { abas } = await this.getDadosCharts()
			const abaGeral = abas?.find(
				(aba) => String(aba.nome)?.toLowerCase() === 'geral'
			)
			if (abaGeral) this.reloadFilter(abaGeral.id)

			this.filterValuesChart(36)
		},

		async getFundacoesAtivos(params = '') {
			try {
				const { data } = await api.get(`${URLS.api_fundacao}?&ativo=True${params}`)

				return data
			} catch (err) {
				errorDefault(err)
			}
		},
	},

	async mounted() {
		GLOBAL.initFlatpickr(document.querySelector('[name=deadline]'), {
			position: 'above',
		})

		const urlParams = new URLSearchParams(window.location.search)
		const az = urlParams.get('az')
		if (!az) {
			await this.setFilterAz(az)
		}
		this.filter_az = az ?? ''
		let data = await this.getDadosCharts()
		let { grafico_importancia_estado, abas } = data
		this.abasFilter = abas

		if (this.getAbaAZById(this.filter_az).toLowerCase() !== 'sequóia') {
			this.alternarValor()
			this.initializeChartToggle()
			this.initAllChart()
			// this.fundacoesAtivos = await this.getFundacoesAtivos(this.filterFundacoes)
			this.iniciartableFundacoesAtivo()
			this.grafico_importancia_estado = grafico_importancia_estado

			setTimeout(() => {
				if (!this.isFundacao) {
					chartSegmento && this.fillCharts(data, chartSegmento)
					chartProdutos && this.fillCharts(data, chartProdutos)
				} else {
					this.chartPle && this.fillCharts(data, this.chartPle)
					this.chartCaptacaoSemestral &&
						this.fillCharts(data.captacoes, this.chartCaptacaoSemestral)
					this.chartCaptacaoMensal &&
						this.fillCharts(data, this.chartCaptacaoMensal)
					this.chartParticipacaoFundo &&
						this.fillCharts(data, this.chartParticipacaoFundo)
				}
				/* this.fillMap() */

				document.querySelector('select[name="usuario_responsavel"]').value =
					urlParams.get('usuario_responsavel')
				this.addEventBtnsFiltroFundacoes()

				this.addBuscaSelect(listOfChoices)
				this.eventProcesso()
				this.populaProcessos()

				this.$nextTick(() => {
					window.dispatchEvent(new Event('resize'))
				})

				this.filterValuesChart(36)
			}, 400)
		}
	},

	beforeMount() {
		this.$nextTick(function () {}.bind(this))
	},

	delimiters: ['{*', '*}'], //delimitadores pra n conflitar com o django
}
